import { render } from "./ModalTabs.vue?vue&type=template&id=39de809b&ts=true"
import script from "./ModalTabs.vue?vue&type=script&lang=ts"
export * from "./ModalTabs.vue?vue&type=script&lang=ts"

import "./ModalTabs.vue?vue&type=style&index=0&id=39de809b&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__